import type { SxProps } from '@mui/material';

import { Box, Link, Stack } from '@mui/material';

import { RouterLink } from 'src/routes/components';

import { parsePrice } from 'src/utils/parsePrice';
import { fCurrency } from 'src/utils/format-number';
import { fDate, fTime } from 'src/utils/format-time';

import { Label } from '../label';
import { Iconify } from '../iconify';

import type { LabelColor } from '../label';

export function RenderLabel({
  children,
  color,
  onClick,
  href,
  sx,
  ...rest
}: {
  children: React.ReactNode;
  color: LabelColor;
  onClick?: () => void;
  href?: string;
  sx?: SxProps;
}) {
  if (href) {
    return (
      <Link
        component={RouterLink}
        href={href}
        underline="none"
        color="inherit"
        sx={{ cursor: 'pointer', ...sx }}
      >
        <Label variant="soft" color={color} {...rest}>
          {children}
        </Label>
      </Link>
    );
  }

  return (
    <Label sx={sx} variant="soft" onClick={onClick} color={color} {...rest}>
      {children}
    </Label>
  );
}

export function RenderEditableCell({ children }: { children: React.ReactNode }) {
  return (
    <Box
      sx={{
        flex: 1,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        '.inline-edit-pen': {
          display: 'none',
        },
        '&:hover': {
          '.inline-edit-pen': {
            display: 'block',
          },
        },
      }}
    >
      {children}
      <Iconify
        className="inline-edit-pen"
        icon="solar:pen-bold"
        sx={{ ml: 1, width: 14, height: 14 }}
      />
    </Box>
  );
}

export function RenderCellCreatedAt({ date }: { date: Date | number }) {
  return (
    <Stack spacing={0.5}>
      <Box component="span">{fDate(date)}</Box>

      <Box component="span" sx={{ typography: 'caption', color: 'text.secondary' }}>
        {fTime(date)}
      </Box>
    </Stack>
  );
}

export function RenderCellPrice({ price }: { price: number }) {
  return fCurrency(parsePrice(price));
}
